import { render, staticRenderFns } from "./flCoupon.vue?vue&type=template&id=4387fd56&scoped=true"
import script from "./flCoupon.vue?vue&type=script&lang=js"
export * from "./flCoupon.vue?vue&type=script&lang=js"
import style0 from "./flCoupon.vue?vue&type=style&index=0&id=4387fd56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4387fd56",
  null
  
)

export default component.exports